// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"41":"bc7f24fb","51":"2f4afe55","110":"a6d1af47","794":"96ea12b2","891":"e430df82"}[chunkId] + ".css";
};